import { render, staticRenderFns } from "./TableHeader.vue?vue&type=template&id=0ed2ce10"
import script from "./TableHeader.vue?vue&type=script&lang=ts"
export * from "./TableHeader.vue?vue&type=script&lang=ts"
import style0 from "./TableHeader.vue?vue&type=style&index=0&id=0ed2ce10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports